import React from 'react';

import { BED_STATES, BED_STATE_META } from '../../../constants/occupancy';

/**
 * MiniOccupancyBar (C2 / FT5) — a per-ward (or org) segmented occupancy bar.
 *
 * Reads ONLY the shared `byState` rollup from `selectOccupancyStats` — it NEVER
 * recomputes a count from a bed list (single-source-of-truth). Segment colours
 * are the explicit `bar` hex from BED_STATE_META so the bar is identical in light
 * and dark mode. Zero-total → an inert empty track (no divide-by-zero, no fake
 * fill).
 */
export default function MiniOccupancyBar({ byState, total }) {
  const t = total || 0;
  return (
    <div
      className="flex h-2 w-full overflow-hidden rounded-full bg-slate-200 dark:bg-slate-700"
      role="img"
      aria-label={
        t === 0
          ? 'No beds'
          : BED_STATES.map((c) => `${byState?.[c] || 0} ${BED_STATE_META[c].label.toLowerCase()}`).join(', ')
      }
      data-testid="mini-occupancy-bar"
    >
      {t > 0 && BED_STATES.map((code) => {
        const n = byState?.[code] || 0;
        if (!n) return null;
        return (
          <span
            key={code}
            data-seg={code}
            style={{ flexGrow: n, backgroundColor: BED_STATE_META[code].bar }}
          />
        );
      })}
    </div>
  );
}
